import { dramaMeta, heroStats } from "@/mocks/drama";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20dramatic%20abstract%20background%20of%20deep%20crimson%20velvet%20curtain%20folds%20with%20warm%20golden%20spotlight%20glow%2C%20theatrical%20moody%20atmosphere%2C%20rich%20shadows%20and%20luxurious%20silky%20texture%2C%20elegant%20tone%2C%20soft%20dramatic%20lighting%2C%20no%20people%2C%20no%20text&width=1920&height=1080&seq=drama-hero-crimson&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/80" />

      <div className="relative mx-auto flex w-full max-w-[1280px] flex-col items-center px-4 py-20 text-center md:px-6 md:py-28 lg:py-32">
        <div className="flex flex-wrap items-center justify-center gap-2">
          {dramaMeta.chips.map((chip) => (
            <span
              key={chip.label}
              className="flex items-center gap-1.5 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-100 backdrop-blur-sm md:text-[13px]"
            >
              <i className={`${chip.icon} text-accent-400`} />
              {chip.label}
            </span>
          ))}
        </div>

        <p className="mt-8 font-label text-sm tracking-[0.35em] text-accent-400">
          全 剧 剧 情 解 析
        </p>
        <h1 className="mt-4 max-w-4xl font-heading text-4xl font-bold leading-tight text-background-50 text-balance md:text-6xl">
          {dramaMeta.title}：大结局与全剧剧情解析
        </h1>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          {dramaMeta.intro}
        </p>

        <div className="mt-9 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
          <a
            href="#ending"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-book-marked-line" />
            阅读大结局解析
          </a>
          <a
            href="#episodes"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-background-50/40 bg-background-50/5 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition hover:bg-background-50/15 sm:w-auto"
          >
            <i className="ri-list-check-2" />
            查看分集脉络
          </a>
        </div>

        <div className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-x-4 gap-y-8 border-t border-background-50/15 pt-8 md:grid-cols-4">
          {heroStats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center">
              <p className="font-heading text-3xl font-bold text-accent-400 md:text-4xl">
                {stat.value}
                <span className="ml-0.5 text-base font-medium text-background-100/80">{stat.unit}</span>
              </p>
              <p className="mt-2 text-xs text-background-100/80 md:text-[13px]">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}